import React, {ReactNode} from 'react';
import MUITableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import classNames from 'classnames';
import {curry} from 'ramda';

import {ColumnType} from '@pluto/table';
import TableCell from './TableCell';

interface TableBodyProps<T> {
    data: T[];
    columns: ColumnType[];
    removedIds: string[];
}

type Render = (node: ReactNode) => ReactNode;

export const customRender = (render: Render, row: ReactNode) => {
    if (render) return render(row);

    return null;
};

const createTableBody = curry(({columns, removedIds}, row) => {
    const cells = [];
    const removed = removedIds.includes(row.id);
    for (const {dataKey, render} of columns) {
        cells.push(
            <TableCell key={dataKey} dataKey={dataKey} title={row[dataKey]}>
                {customRender(render, row)}
            </TableCell>
        );
    }

    return (
        <TableRow
            key={row.id}
            className={classNames({
                removed,
            })}
        >
            {cells}
        </TableRow>
    );
});

function getDataForTable<T>(tableData: TableBodyProps<T>) {
    const {data, columns, removedIds} = tableData;
    const tableBody = createTableBody({
        columns,
        removedIds,
    });
    return data.map(tableBody);
}

export default function TableBody<T>(props: TableBodyProps<T>) {
    const {data, columns, removedIds} = props;

    const rows = getDataForTable({
        data,
        columns,
        removedIds,
    });
    return <MUITableBody>{rows}</MUITableBody>;
}

TableBody.defaultProps = {
    removedIds: [],
};
